
import { api } from '../core';
import { AppConfig } from '../../types';
import { localDB } from '../helpers';

// Default configuration ensures 'local' mode is the starting point for the entire project.
const DEFAULT_CONFIG: AppConfig = {
  dialect: 'najdi',
  ttsEnabled: true,
  voice: 'Kore',
  speechSpeed: 1.0,
  theme: 'dark',
  mode: 'chat',
  language: 'ar',
  hasSeenOnboarding: false,
  dataSourceMode: 'local', // Forced default to Local
  apiKey: ''
};

export const ConfigService = {
  getConfig: async (): Promise<AppConfig> => {
    return api.execute<AppConfig>(
      '/config',
      async () => {
        // Fallback to DEFAULT_CONFIG which enforces 'local' mode if no config exists
        return localDB.get<AppConfig>('lahja_config', DEFAULT_CONFIG);
      }
    );
  },

  updateConfig: async (updates: Partial<AppConfig>): Promise<AppConfig> => {
    return api.execute<AppConfig>(
      '/config',
      async () => {
        const current = localDB.get<AppConfig>('lahja_config', DEFAULT_CONFIG);
        const updated = { ...current, ...updates };
        localDB.set('lahja_config', updated);
        return updated;
      },
      { method: 'PATCH', body: JSON.stringify(updates) }
    );
  }
};
